import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  template: `
    <div class="form-group">
      <label *ngIf="!!label" for="{{ id }}">{{ label }}</label>
      <div class="input-group">
        <span class="input-group-addon">
          <div (click)="toggleColorPicker()" class="square mdc-elevation--z1 b-r-sm" [ngStyle]="{'background-color':value}"></div>
        </span>
        <input id="{{ id }}" (blur)="toggleColorPicker(false)" (focus)="toggleColorPicker()" class="form-control"
          type="text" [(ngModel)]="value">
      </div>
      <color-picker hide="true" id="{{ colorPickerId }}" [(value)]="value" ></color-picker>
    </div>
  `,
  styles: [
    `
      .form-control {
        border: none;
        border-radius: 0 10px 10px 0 !important;
      }
      .input-group-addon {
        border: none;
        border-radius: 10px 0 0 10px !important;
      }
    `
  ],
  selector: 'input-color'
})
export class InputColorComponent implements OnInit, OnDestroy {
  @Input('label') public label: string;

  public id: string;
  public colorPickerId: string;

  // public color: string;

  @Output() public valueChange: EventEmitter<string> = new EventEmitter<string>();
  private _value: string;
  @Input('value') public get value() { return this._value; }
  public set value(v: string) {
    this._value = v;
    this.valueChange.emit(this._value);
  }

  constructor() {}

  ngOnInit() {
    this.id = '_id_' + Math.floor(Math.random() * 999 + 100);
    this.colorPickerId = `${this.id}_color_picker_`;
  }

  ngOnDestroy(): void {}

  toggleColorPicker(name, show = true) {
    jQuery('#' + this.colorPickerId + ' .color-picker-wrapper').css('justify-content', 'left');
    const container = jQuery('#' + this.colorPickerId + ' .color-container');
    if (show && !container.hasClass('color-container-open')) {
      return container.addClass('color-container-open');
    }
    container.removeClass('color-container-open');
  }


}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/common-livee/input-color.component.ts